import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticTractorsMetaConfigMapper extends Mapper {
  map = ({adsListSemanticConfig}) => {
    return adsListSemanticConfig.default
  }
}
